export const setDataProjectState = (state, action): any => {
  const updatedState = {
    ...state,
    DataProject: action.payload.data,
  };

  return updatedState;
};
